import { createElement } from "react";
import type { PropsWithChildren } from "react";

import { Defs as SvgDefs } from "react-native-svg";

// fixes Defs not working across native and web
const Defs = ({ children }: PropsWithChildren) =>
  createElement(SvgDefs, null, children);

export * from "react-native-svg";
export { default } from "react-native-svg";
export { Defs };
